import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { QuestionComponent } from '../abstract/question.component'
import { map, shareReplay } from 'rxjs/operators';
import { get } from 'lodash';
import { Observable } from 'rxjs';
import { PieChartComponent } from '@swimlane/ngx-charts';
import { ReplyItem } from '../../../../../classes';

@Component({
  selector: 'question-radio',
  templateUrl: './question-radio.component.html',
  styleUrls: ['./question-radio.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class QuestionRadioComponent extends QuestionComponent {
  @ViewChild(PieChartComponent) chart:PieChartComponent
  private _results:{name:string, value:number}[];
  private _replatedReplyList:ReplyItem[];
  results:Observable<{name:string, value:number}[]> = this.relatedReplyList
  .pipe(
    map(list=>this.turnListIntoStatistics(list)),
    shareReplay(1)
  )
  
  ngOnInit () {
    this.charts.set(this.question.id, this.chart);
    this.relatedReplyList.subscribe(list=>{
      this._replatedReplyList = list;
    })
    this.results.subscribe(results=>{
      this._results = results
    });
  }
  turnListIntoStatistics (list:ReplyItem[]) {
    return this.question.options.map(o=>{
      return { name:o.text, value: list.filter(li=>get(li, ['snapshot', o.question.id, o.id])).length }
    })
  }
  labelFormatting (name) {
    const result = this._results.find(result=>result.name === name);
    return `${Math.round((1000 * result.value) / this._replatedReplyList.length) / 10 }% ${name}`;
  }
  onSelect(text:string) {
    const option = this.question.getOptions({text})[0];
    if (option) {
      this.repliesPerOptionModal.open(
        option,
        this.replies.list.pipe(
          map(list=>list.filter(li=>get(li, ['snapshot', this.question.id, option.id]))),
        )
      )
    } 
    console.log(event);
  }
}
